<ng-template [ngIf]="templateOptions.options" [ngIfElse]="singleCheckbox">
  <div
    [ngClass]="{ 'checkbox-group__item--inline': templateOptions.inline }"
    *ngFor="let option of templateOptions.options | formlySelectOptions:field | async; trackBy: trackOption; let i = index;"
  >
    <mat-checkbox
      [id]="id + '_' + i"
      [formlyAttributes]="field"
      [disabled]="option.disabled"
      [tabindex]="templateOptions.tabindex || 0"
      [color]="templateOptions.color"
      [labelPosition]="templateOptions.labelPosition"
      [checked]="isChecked(option)"
      (change)="onChange(option, $event.checked)"
    >
      {{ option.label }}
    </mat-checkbox>
  </div>
</ng-template>

<ng-template #singleCheckbox>
  <mat-checkbox
    [id]="id"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [tabindex]="templateOptions.tabindex || 0"
    [color]="templateOptions.color"
    [labelPosition]="templateOptions.labelPosition"
  >
    {{ templateOptions.label }}
  </mat-checkbox>
  <span
    *ngIf="templateOptions.afterCheckbox"
    class="privatePolicy"
    [innerHTML]="safeHTML(templateOptions.afterCheckbox)"
  ></span>
</ng-template>
